// Generated by tools/worlds/extract_jomo_object_action_bindings.py.
// Do not classify additional objects here without extending the native trace.

export const JOMO_POSITION_X_BINDINGS = Object.freeze({
  "IWWH": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 1,
    "actionId": 15
  },
  "BMB1": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 4,
    "actionId": 10
  },
  "BMB2": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 4,
    "actionId": 11
  },
  "BMB4": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 4,
    "actionId": 9
  },
  "BMB5": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 4,
    "actionId": 20
  },
  "D1C1": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 6,
    "actionId": 13
  },
  "D1C2": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 6,
    "actionId": 16
  },
  "IMC1": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 5,
    "actionId": 14
  },
  "IMC2": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 5,
    "actionId": 22
  },
  "AKD2": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 0,
    "actionId": 1
  },
  "AKD3": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 0,
    "actionId": 2
  },
  "AKD4": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 0,
    "actionId": 5
  },
  "ATS1": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 0,
    "actionId": 40
  },
  "ATS2": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 0,
    "actionId": 41
  },
  "ATS3": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 0,
    "actionId": 42
  },
  "ATS4": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 0,
    "actionId": 43
  },
  "ATS5": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 0,
    "actionId": 44
  },
  "ATS6": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 0,
    "actionId": 45
  },
  "ITS1": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 3,
    "actionId": 30
  },
  "ITS2": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 3,
    "actionId": 31
  },
  "ITS3": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 3,
    "actionId": 32
  },
  "ITS4": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 3,
    "actionId": 33
  },
  "ITS5": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 3,
    "actionId": 34
  },
  "ITS6": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 3,
    "actionId": 35
  },
  "FKWH": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 2,
    "actionId": 39
  },
  "IKD1": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 3,
    "actionId": 37
  },
  "IKD2": {
    "groupIndex": 0,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 3,
    "actionId": 38
  },
  "D1C3": {
    "groupIndex": 1,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 6,
    "actionId": 17
  },
  "D1C4": {
    "groupIndex": 1,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 6,
    "actionId": 17
  },
  "TAN1": {
    "groupIndex": 1,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 8,
    "actionId": 27
  },
  "TAN2": {
    "groupIndex": 1,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 13,
    "actionId": 27
  },
  "GGB1": {
    "groupIndex": 1,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 13,
    "actionId": 28
  },
  "GGB2": {
    "groupIndex": 1,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 8,
    "actionId": 28
  },
  "IMC3": {
    "groupIndex": 1,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 5,
    "actionId": 21
  },
  "IMC4": {
    "groupIndex": 1,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 5,
    "actionId": 21
  },
  "DND1": {
    "groupIndex": 1,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 6,
    "actionId": 29
  },
  "DND2": {
    "groupIndex": 1,
    "engineSelector": 10,
    "transformChannel": "positionX",
    "actionRouteNodeOrVariant": 6,
    "actionId": 29
  }
});

export const JOMO_POSITION_X_PAIRS = Object.freeze({
  "D1C3": {
    "pairId": "D1C",
    "partnerTag": "D1C4",
    "actionRouteNodeOrVariant": 6,
    "engineSelector": 10,
    "transformChannel": "positionX"
  },
  "D1C4": {
    "pairId": "D1C",
    "partnerTag": "D1C3",
    "actionRouteNodeOrVariant": 6,
    "engineSelector": 10,
    "transformChannel": "positionX"
  },
  "TAN1": {
    "pairId": "TAN",
    "partnerTag": "TAN2",
    "actionRouteNodeOrVariant": 8,
    "engineSelector": 10,
    "transformChannel": "positionX"
  },
  "TAN2": {
    "pairId": "TAN",
    "partnerTag": "TAN1",
    "actionRouteNodeOrVariant": 13,
    "engineSelector": 10,
    "transformChannel": "positionX"
  },
  "GGB1": {
    "pairId": "GGB",
    "partnerTag": "GGB2",
    "actionRouteNodeOrVariant": 13,
    "engineSelector": 10,
    "transformChannel": "positionX"
  },
  "GGB2": {
    "pairId": "GGB",
    "partnerTag": "GGB1",
    "actionRouteNodeOrVariant": 8,
    "engineSelector": 10,
    "transformChannel": "positionX"
  },
  "IMC3": {
    "pairId": "IMC",
    "partnerTag": "IMC4",
    "actionRouteNodeOrVariant": 5,
    "engineSelector": 10,
    "transformChannel": "positionX"
  },
  "IMC4": {
    "pairId": "IMC",
    "partnerTag": "IMC3",
    "actionRouteNodeOrVariant": 5,
    "engineSelector": 10,
    "transformChannel": "positionX"
  },
  "DND1": {
    "pairId": "DND",
    "partnerTag": "DND2",
    "actionRouteNodeOrVariant": 6,
    "engineSelector": 10,
    "transformChannel": "positionX"
  },
  "DND2": {
    "pairId": "DND",
    "partnerTag": "DND1",
    "actionRouteNodeOrVariant": 6,
    "engineSelector": 10,
    "transformChannel": "positionX"
  }
});
